export default __webpack_public_path__ + "static/media/crossbar-purple.da00f142.svg";